export default __webpack_public_path__ + "static/media/barcelona_logo.b882a73a.png";